import { defineAsyncComponent } from 'vue'

const MAP_DVP = [
  {
    name: 'LoginForm',
    component: defineAsyncComponent(() => import('@shared/components/Softlogin/steps/LoginForm'))
  },
  {
    name: 'LoginTan',
    component: defineAsyncComponent(() => import('@shared/components/Softlogin/steps/LoginTan'))
  },
  {
    name: 'PersonSelect',
    component: defineAsyncComponent(() => import('@shared/components/Softlogin/steps/PersonSelect'))
  },
  {
    name: 'PersonForm',
    component: defineAsyncComponent(() => import('@shared/components/Softlogin/steps/PersonForm'))
  },
  {
    name: 'Loading',
    component: defineAsyncComponent(() => import('@shared/components/Softlogin/steps/Loading'))
  },
  {
    name: 'Success',
    component: defineAsyncComponent(() => import('@shared/components/Softlogin/steps/Success'))
  }
]

const MAP_PARTNER = [
  {
    name: 'Intro',
    component: defineAsyncComponent(() => import('@shared/components/Softlogin/steps/AdvisorIntro'))
  },
  {
    name: 'PersonSelect',
    component: defineAsyncComponent(() => import('@shared/components/Softlogin/steps/PersonSelect'))
  },
  {
    name: 'PersonForm',
    component: defineAsyncComponent(() => import('@shared/components/Softlogin/steps/PersonForm'))
  },
  {
    name: 'Loading',
    component: defineAsyncComponent(() => import('@shared/components/Softlogin/steps/Loading'))
  },
  {
    name: 'Success',
    component: defineAsyncComponent(() => import('@shared/components/Softlogin/steps/Success'))
  }
]

const MAP_PORTAL = [
  {
    name: 'Intro',
    component: defineAsyncComponent(() => import('@shared/components/Softlogin/steps/PortalIntro'))
  },
  {
    name: 'PersonSelect',
    component: defineAsyncComponent(() => import('@shared/components/Softlogin/steps/PersonSelect'))
  },
  {
    name: 'PersonForm',
    component: defineAsyncComponent(() => import('@shared/components/Softlogin/steps/PersonForm'))
  },
  {
    name: 'Loading',
    component: defineAsyncComponent(() => import('@shared/components/Softlogin/steps/Loading'))
  },
  {
    name: 'Success',
    component: defineAsyncComponent(() => import('@shared/components/Softlogin/steps/Success'))
  }
]

const MAP_PORTAL_LEGACY = [
  {
    name: 'success',
    component: defineAsyncComponent(() => import('@shared/components/Softlogin/steps/PortalIntroLegacy'))
  },
  {
    name: 'Intro',
    component: defineAsyncComponent(() => import('@shared/components/Softlogin/steps/PortalIntro'))
  },
  {
    name: 'PersonSelect',
    component: defineAsyncComponent(() => import('@shared/components/Softlogin/steps/PersonSelect'))
  },
  {
    name: 'PersonForm',
    component: defineAsyncComponent(() => import('@shared/components/Softlogin/steps/PersonForm'))
  },
  {
    name: 'Loading',
    component: defineAsyncComponent(() => import('@shared/components/Softlogin/steps/Loading'))
  },
  {
    name: 'Success',
    component: defineAsyncComponent(() => import('@shared/components/Softlogin/steps/Success'))
  }
]

export const SOFTLOGIN_STEP_MAP = {
  DVP: MAP_DVP,
  PARTNER: MAP_PARTNER,
  PORTAL: MAP_PORTAL,
  PORTAL_LEGACY: MAP_PORTAL_LEGACY,
}
